import { groupCls, itemCls } from './atom.group.style.js';
import { jsx } from 'react/jsx-runtime';

const Group = ({
  children
}) => {
  return /*#__PURE__*/jsx("li", {
    className: groupCls,
    children: /*#__PURE__*/jsx("ul", {
      children: Array.isArray(children) ? children.map((child, index) => /*#__PURE__*/jsx("li", {
        className: itemCls,
        children: child
      }, index)) : /*#__PURE__*/jsx("li", {
        className: itemCls,
        children: children
      })
    })
  });
};

export { Group };
//# sourceMappingURL=atom.group.js.map
